import { createFileRoute } from "@tanstack/react-router";

import { PublicSpecArchivedPage } from "@/components/specifications/public-spec-archived-page";
import { PublicSpecLayout } from "@/components/specifications/public-spec-layout";
import { publicShareHead } from "@/lib/share-token";

// **The share links' landing** — `/public-spec-archived[?reason=link-invalid]`
// (#1022; `public-spec-archived-page.tsx`): where a link that opens nothing
// ends, in one of the source's two wordings. Public, top-level and outside
// `_authed/`, named in `routes-layout.unit.test.ts`. It renders the public
// layout's logo-only face: the source hides Copy Link and Print here.
export const Route = createFileRoute("/public-spec-archived")({
  head: publicShareHead,
  // `reason` read as the text the link carries; anything that is not exactly
  // `link-invalid` reads as the default (`:20-22`).
  validateSearch: (search: Record<string, unknown>): { reason?: unknown } =>
    search.reason === undefined ? {} : { reason: search.reason },
  component: PublicSpecArchivedRoute,
});

function PublicSpecArchivedRoute() {
  const { reason } = Route.useSearch();
  return (
    <PublicSpecLayout>
      <PublicSpecArchivedPage reason={reason} />
    </PublicSpecLayout>
  );
}
